// extracted by mini-css-extract-plugin
export default {"container":"MenuLayouts_container__0lLF4"};